import React, { useEffect } from 'react';
import './Footer.css'
import { Link as Anchor } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingBag } from '@fortawesome/free-solid-svg-icons';
import { useCatalogData } from '../CatalogData/CatalogDataProvider';

const fallbackLogo = '/brand/inksu-logo-horizontal.png';

const getSafeExternalUrl = (value) => {
    try {
        const url = new URL(String(value ?? '').trim());
        return url.protocol === 'http:' || url.protocol === 'https:'
            ? url.toString()
            : '';
    } catch (error) {
        return '';
    }
};

const getSafeEmail = value => {
    const email = String(value ?? '').trim();
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) ? email : '';
};

const getSafePhone = value => {
    const phone = String(value ?? '').trim().replace(/[^\d+]/g, '');
    return /\d{6,}/.test(phone) ? phone : '';
};

export default function Footer() {
    const { tiendaPrincipal, ensureTienda } = useCatalogData();
    const direccion = String(tiendaPrincipal?.direccion ?? '').trim();
    const email = getSafeEmail(tiendaPrincipal?.email);
    const telefono = getSafePhone(tiendaPrincipal?.telefono);
    const instagram = getSafeExternalUrl(tiendaPrincipal?.instagram);
    const facebook = getSafeExternalUrl(tiendaPrincipal?.facebook);

    useEffect(() => {
        ensureTienda().catch(() => {});
    }, [ensureTienda]);

    return (
        <div className='FooterContain'>
            <div className='footerText' id='footerText'>
                <Anchor to='/'>
                    {tiendaPrincipal?.imagen1 ? (
                        <img src={tiendaPrincipal.imagen1} alt={tiendaPrincipal?.nombre || 'INK-SU'} loading="lazy" decoding="async" />
                    ) : (
                        <img src={fallbackLogo} alt="INK-SU" loading="lazy" decoding="async" />
                    )}
                </Anchor>

                <h2>{tiendaPrincipal?.nombre || 'INK-SU'}</h2>
            </div>

            <div className='footerText'>
                <h3>Contacto Sucursal</h3>
                {direccion && (
                    <Anchor to={`https://www.google.com/maps?q=${encodeURIComponent(direccion)}`} target="_blank">
                        {direccion}
                    </Anchor>
                )}
                {email && <Anchor to={`mailto:${email}`}>{email}</Anchor>}
                <div className='socials'>
                    {instagram && (
                        <Anchor to={instagram} target="_blank" aria-label='Instagram'>
                            <i className='fa fa-instagram'></i>
                        </Anchor>
                    )}
                    {telefono && (
                        <Anchor to={`tel:${telefono}`} aria-label='Teléfono'>
                            <i className='fa fa-whatsapp'></i>
                        </Anchor>
                    )}
                    {facebook && (
                        <Anchor to={facebook} target="_blank" aria-label='Facebook'>
                            <i className='fa fa-facebook'></i>
                        </Anchor>
                    )}
                </div>
            </div>


            <div className='footerText'>
                <h3>Navegación</h3>
                <Anchor to={`/productos`}>
                <FontAwesomeIcon icon={faShoppingBag} />
                
                <span> Ver Todos los Productos</span>
                </Anchor>
            </div>

        </div>
    );
}
